import React from 'react';
import AccessContainer from './AccessContainer';

interface Props {
  returnUrl: string;
}

const AccessPage: React.FC<Props> = ({ returnUrl }) => <AccessContainer returnUrl={returnUrl} />;

export default AccessPage;
